<div class="action-bar" [class.stacked]="actions?.length >= 2">
    <div class="action-bar__back-actions">
        <button *ngIf="isBackVisible" class="ui button secondary first" (click)="handleBack()">
            {{ labels.back }}
        </button>
        <button *ngIf="isCancelVisible" class="ui button secondary second" (click)="handleCancel()">
            {{ labels.cancel }}
        </button>
    </div>
    <div *ngIf="eventService.isLoading" class="action-bar-loader">
        <p>Working</p>
        <img src="/assets/images/animations/loader-rocket.svg" />
    </div>
    <div *ngIf="!eventService.isLoading" class="action-bar__next-actions">
        <ng-container *ngFor="let action of actions">
            <button
                class="ui button blue third"
                [ngClass]="{ disabled: eventService.isNextDisabled }"
                (click)="handleNext(action)"
            >
                <i *ngIf="action.icon" class="icon {{ action.icon }}"></i>
                {{ action.canOverwrite ? labels.next || action.label : action.label }}
            </button>
        </ng-container>
    </div>
</div>
